import React from 'react';
import { Empty as AntdEmpty, EmptyProps } from 'antd';

export default function Empty(props?: EmptyProps) {

  return (
    <AntdEmpty
      style={{ padding: '60px 0' }}
      image={
        <img
          style={{ width: 120, height: 120, marginBottom: 16 }}
          src="https://oss.elebuys.com/resource/goods/materials/202404131402380003387150.png"
        />
      }
      description={<div style={{ marginTop: 24, color: '#aaa' }}>没有任何信息</div>}
      {...props}
    />
  );
}
